<template>
    <v-row class="ma-0">
        <v-col cols="6">
            <v-subheader class="primary--text pa-0 ma-0 h-auto mb-1 text-capitalize">New Amount</v-subheader>
            <v-text-field ref="amount" type="number" placeholder="New Amount" hide-details="auto" v-model.number="model.amount"
                :error-messages="$helpers.errorMsg('number', $v.model.amount, 'New Amount')"
                outlined  prepend-inner-icon="mdi-currency-usd" required
                @focus="$helpers.avoidInputScrollable" @keydown="$helpers.avoidInputArrowKeyPress"></v-text-field>
        </v-col>
        <v-col v-if="enableFee" cols="12" class="pa-0 ma-0 mt-2">
            <p class="body-2 primary--text mb-2">Did you know that not every cent of your donation stays at TheLight? {{ stripeFeeText }} of every donation goes towards external processing fees! Would you like to cover the ${{ processingFee.toFixed(2) }} processing fee?</p>
        </v-col>
        <v-col v-if="enableFee"  cols="12" class="pa-0 ma-0">
            <v-checkbox v-model="model.cover_fee" color="secondary" hide-details class="ma-0 pa-0" :label="`Yes, I would like to cover the $${processingFee.toFixed(2)} fee`" />
        </v-col>
        <v-col v-if="enableFee"  cols="6" class="pa-0 ml-auto pl-3">
            <div class="other-amount rounded-lg d-flex justify-space-between mt-2">
                <div class="left-box primary--text w-full font-weight-bold d-flex justify-end align-center px-4 py-2">
                    Total including fee
                </div>
                <div class="right-box w-full d-flex align-center px-4 py-2 primary--text font-weight-bold">
                    <v-text-field readonly outlined hide-details dense class="ma-0 pa-0 text-right" :value="`$${totalIncludingFee.toFixed(2)}`" />
                </div>
            </div>
        </v-col>
         <v-col cols="12">
            <v-card-actions class="pa-0">
                <v-row class="ma-0 pa-3" align="center" justify="end">
                    <v-btn :disabled="loading" color="primary" class="text-capitalize mr-3" @click="openNotify()">Save</v-btn>
                    <v-btn :disabled="loading" color="secondary" class="text-capitalize" @click="$emit('enableAct', false)">Cancel</v-btn>
                </v-row>
            </v-card-actions>
        </v-col>
        <notify-modal :loading="loading" :modalData="modalData" :open="openModal" @save="saveNotify" @close="openModal = false"/>
    </v-row>
</template>


<script>
import { required, minValue } from "vuelidate/lib/validators";
import { mapActions } from 'vuex';

export default {
    props: ['modelData'],
    emits: ['enableAct'],
    components: {
        NotifyModal: () => import("@/pages/admin/sf-opportunity/components/NotifyModal"),
    },
    data: (vm) => ({
        enableFee: false,
        model: {
            amount: 0,
            cover_fee: false,
            cover_amount: 0,
        },
        openModal: false,
        loading: false,
        defaultModel: {},
        modalData: {
            name: 'save',
            items: [],
            tableNotFound: 'No Data Found!.',
            headers: [
                { text: 'Field', value: 'field' },
                { text: 'Previous', value: 'prev' },
                { text: 'New', value: 'new' }
            ]
        },
        defaultStripeFee: { percentage: 1.7, flat: 0.3 },
    }),
    computed: {
        processingFee() {
            const amt = Number(this.model.amount) || 0;
            if (!amt || amt <= 0) return 0;
            const p = Number(this.defaultStripeFee && this.defaultStripeFee.percentage) || 0;
            const f = Number(this.defaultStripeFee && this.defaultStripeFee.flat) || 0;
            const fee = amt * (p / 100) + f;
            return Math.round(fee * 100) / 100;
        },
        totalIncludingFee() {
            const amt = Number(this.model.amount) || 0;
            return amt + (this.model.cover_fee ? this.processingFee : 0);
        },
        stripeFeeText() {
            const p = Number(this.defaultStripeFee && this.defaultStripeFee.percentage) || 0;
            const f = Number(this.defaultStripeFee && this.defaultStripeFee.flat) || 0;
            return `${p.toFixed(2)}%${f > 0 ? ` + A$${f.toFixed(2)}` : ''}`;
        },
    },
    validations: {
        model: {
            amount: { required, minValue: minValue(1)},
        }
    },
    watch: {
        modelData: {
            handler: function(newVal) {
                this.defaultModel = newVal;
                if (newVal) {
                    this.model.amount = newVal.amount;
                    this.model.cover_fee = newVal.cover_fee || false;
                    this.model.cover_amount = newVal.cover_amount || 0;
                }
            },
            deep: true,
            immediate: true
        },
        'model.cover_fee': function (newVal) {
            if (newVal) {
                this.model.cover_amount = this.processingFee;
            } else {
                this.model.cover_amount = 0;
            }
        },
        'model.amount': function (newVal) {
            if (this.model.cover_fee) {
                this.model.cover_amount = this.processingFee;
            }
        }
    },
    created() {
        this.defaultModel = this.modelData;
      this.getSelectAppSettingData('STRIPE_FEE').then(resp => {
        const data = resp.data?.data || null;
        if (data && data.option_value) {
          this.defaultStripeFee = data.option_value;
        }
      }).catch(err => console.error('Stripe Fee fetch error:', err));
    },
    methods: {
        ...mapActions(['updateDonateAmt', 'getSelectAppSettingData']),

        openNotify() {
            this.$v.$touch();
            if (this.$v && this.$v.$invalid) {
                this.$helpers.focusErrorElement(this.$v.model, this.$refs);
                return;
            }
            this.modalData.items = [
              {field: 'amount', prev: this.defaultModel.amount,new: this.model.amount }
            ];

          if (this.defaultModel.cover_fee !== this.model.cover_fee) {
            this.modalData.items.push({field: 'cover_fee', prev: this.defaultModel.cover_fee ? 'Yes' : 'No', new: this.model.cover_fee ? 'Yes' : 'No' });
          }

          if (this.defaultModel.cover_amount !== this.model.cover_amount) {
            this.modalData.items.push({field: 'cover_amount', prev: this.defaultModel.cover_amount, new: this.model.cover_amount });
          }

          console.log(`this.modalData.items`, this.modalData.items)

            this.openModal = true;
            this.$emit('enableAct', true);
        },
        saveNotify() {
            this.loading = true;
            this.updateDonateAmt({id: this.defaultModel.id, reqData: this.model}).then(resp => {
                this.openModal = false;
                this.loading = false;
                this.$emit('modelUpdate', {field: 'amount', value: this.model.amount });
                this.$emit('modelUpdate', {field: 'cover_fee', value: this.model.cover_fee });
                this.$emit('modelUpdate', {field: 'cover_amount', value: this.model.cover_amount });
                this.$emit('enableAct', false);
            }).catch(err =>  this.loading = false)
        }
    }
}
</script>
